import Environment from '@config/index';
import { ApiResponse } from '@interfaces/api';
import { axios, getAxiosConfig } from '@config/axios';
import { flattenObject } from '@helpers/seller-info-helpers';
import {
  IBillingAddress,
  IFlattenedSellerInformation,
  SellerInfoFormPayload,
} from '@interfaces/models/seller-info/seller-information';

const BASE_URL = Environment.apiBaseUrl;

export const getUserBillingAddress = async (): Promise<IFlattenedSellerInformation> => {
  const axiosConfig = getAxiosConfig();
  const {
    data: { data },
  } = await axios.get<ApiResponse<IBillingAddress>>(`${BASE_URL}/users/me/addresses/flags/billing`, axiosConfig);
  const flattenedData: IFlattenedSellerInformation = flattenObject(data);
  flattenedData.country = flattenedData.iso2;
  flattenedData.street = flattenedData.label;
  return flattenedData;
};

export const getUserTaxInformation = async (): Promise<IFlattenedSellerInformation> => {
  const axiosConfig = getAxiosConfig();
  const {
    data: { data },
  } = await axios.get(`${BASE_URL}/kyc/customers/tax_information`, axiosConfig);
  const flattenedData: IFlattenedSellerInformation = flattenObject(data);
  return flattenedData;
};

export const saveUserTaxInformation = async (payload: SellerInfoFormPayload): Promise<IFlattenedSellerInformation> => {
  const axiosConfig = getAxiosConfig();
  const {
    data: { data },
  } = await axios.post(`${BASE_URL}/kyc/customers/tax_information`, payload, axiosConfig);
  const flattenedData: IFlattenedSellerInformation = flattenObject(data);
  return flattenedData;
};

export const updateUserTaxInformation = async (
  payload: SellerInfoFormPayload,
): Promise<IFlattenedSellerInformation> => {
  const axiosConfig = getAxiosConfig();
  const {
    data: { data },
  } = await axios.patch(`${BASE_URL}/kyc/customers/tax_information`, payload, axiosConfig);
  const flattenedData: IFlattenedSellerInformation = flattenObject(data);
  return flattenedData;
};
